import Moment from 'moment'
export class Converter {
    static languageCodeToLanguage(languageCode: string, localizer: (id: string) => string): string {
        switch (languageCode) {
            case 'K': return localizer('Danish')
            case 'D': return localizer('German')
            case 'E': return localizer('English')
            case 'V': return localizer('Swedish')
            default: return languageCode
        }
    }

    static toLocalDate(isoUtcDate: string | null): Date | undefined {
        return (isoUtcDate == null)
            ? undefined
            : Moment.utc(isoUtcDate).local().toDate()
    }
}